/* eslint-disable no-prototype-builtins */
const memoria = {};

// return the user data from the session storage
export const getUnidad = () => sessionStorage.getItem('unidad') || null;

// return the token from the session storage
/* export const getToken = () => {
  return sessionStorage.getItem('token') || null;
}; */

export const getPermissions = () => {
  const item = sessionStorage.getItem('permission');
  return item != null ? JSON.parse(item) : null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.clear();
};
// set the token and user from the session storage
/* export const setUserSession = (token) => {
  sessionStorage.setItem('token', token);
}; */

export const setMapsDatos = (key, mapDatos) => {
  const datos = JSON.stringify(mapDatos);
  memoria[key] = datos;
  try {
    sessionStorage.setItem(key, datos);
  } catch (err) {
    console.log('npi', err);
  }
};

export const getMapDatos = (key) => {
  if (memoria.hasOwnProperty(key)) {
    return JSON.parse(memoria[key]);
  }
  return JSON.parse(sessionStorage.getItem(key)) || null;
};

export const inMemory = (key) => {
  if (memoria.hasOwnProperty(key)) {
    return true;
  }
  // console.log('inMemory', key, sessionStorage.getItem(key), sessionStorage.getItem(key) !== null)
  return sessionStorage.getItem(key) !== null;
};

export const setSessionId = (unidad) => {
  sessionStorage.setItem('unidad', unidad);
};

export const setPermissionsStorage = (permission) => {
  const datos = JSON.stringify(permission);
  sessionStorage.setItem('permission', datos);
};

export const setMapsCalculos = (mapsCaculos) => {
  const datos = JSON.stringify(mapsCaculos);
  memoria.calculos = datos;
  try {
    sessionStorage.setItem('calculos', datos);
  } catch (err) {
    console.log('npi', err);
  }
};
